import { Popover as AntdPopover } from "antd";
import type { PopoverProps as AntdPopoverProps } from "antd";

export type PopoverProps = AntdPopoverProps
export const Popover = AntdPopover;
